import * as React from 'react';

import styled from 'styled-components';

import Flex from '@components/layout/flex';
import Typography from '@components/basics/typography';

import { RecordLabel } from '@common/types/record-label/record-label';
import { Translate } from 'react-localize-redux';
import SquareAvatar from '../../basics/square-avatar';

interface LabelListItemProps {
  className?: string;
  label: RecordLabel;
  artistQty?: number;
  isOwner: boolean;
}

export const LabelListItem: React.FC<LabelListItemProps> = (props) => {
  const getInitials = (name?: string) => {
    if (name) {
      return name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .slice(0, 2);
    }
    return;
  };

  return (
    <>
      <Flex
        alignItems="center"
        justifyContent="flex-start"
        className={props.className}
      >
        {props.label.avatar ? (
          <StyledSquareAvatar src={props.label.avatar} size={32} />
        ) : (
          <LabelAvatar>
            <Typography type="small" weight="700" uppercase>
              {getInitials(props.label.name)}
            </Typography>
          </LabelAvatar>
        )}
        <LabelNameWrapper>
          {props.label.name && (
            <Typography className="label-name">
              {props.label.name.length > 25
                ? `${props.label.name.slice(0, 25)}...`
                : props.label.name}
            </Typography>
          )}
          <Typography type="small" className="label-qty">
            {props?.artistQty && props.artistQty > 1 ? (
              <Translate
                id="DASHBOARD.ARTIST_MENU.ARTISTS"
                data={{ amount: props.artistQty }}
              />
            ) : (
              <Translate id="DASHBOARD.ARTIST_MENU.ARTIST" />
            )}
          </Typography>
        </LabelNameWrapper>
        <Typography className="role" type="small" weight="700" uppercase>
          {props.isOwner ? (
            <Translate id="DASHBOARD.ARTIST_MENU.LABEL.OWNER" />
          ) : (
            <Translate id="DASHBOARD.ARTIST_MENU.LABEL.OPERATOR" />
          )}
        </Typography>
      </Flex>
      {props.children}
    </>
  );
};

export default styled(LabelListItem)`
  user-select: none;
  position: relative;

  ${({ theme }) => `@media screen and ${theme.device.tablet}`} {
    margin-right: 72px;
  }

  .label-name {
    font-weight: 700;
  }

  .label-qty {
    margin-top: 2px;
  }

  .icon {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translate(0, -50%);
  }
`;

const StyledSquareAvatar = styled(SquareAvatar)`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
}`;

const LabelAvatar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 4px;
  margin-right: 16px;
  overflow: hidden;
`;

const LabelNameWrapper = styled.div`
  flex-grow: 1;
`;
